import React from 'react';
import PropTypes from 'prop-types';
import withModal from '../../Modal/WithModal';
import { ViewerPrimaryColorUserStyle } from '../../UserCustomization';
import svgInline from '../../SvgInline/SvgInline';
import closeIcon from '../../../shared/assets/icon-close.svg';
// import addFolderIcon from '../../../shared/assets/icon-new-folder.svg';
// import deleteFolderIcon from '../../../shared/assets/icon-trash.svg';
// import renameFolderIcon from '../../../shared/assets/icon-edit.svg';
import folderManager from '../../../shared/assets/folder-manager.png';
import foldersModalMultiselectImg from '../../../shared/assets/folders-modal-multiselect.png';
import addFolderImg from '../../../shared/assets/folder-create-btn.png';
import deleteFolderImg from '../../../shared/assets/folder-delete-btn.png';
import renameFolderImg from '../../../shared/assets/folder-rename-btn.png';
import folderBulkActionImg from '../../../shared/assets/folder-bulk.png';
import folderBulkAddImg from '../../../shared/assets/folder-bulk-add.png';
import folderBulkRemoveImg from '../../../shared/assets/folder-bulk-remove.png';
import foldersFullImg from '../../../shared/assets/folders-full.png';
import folderIcon from '../../List/icon-folder.svg';
import folderIconActive from '../../List/icon-folder-active.svg';
import siteMarker from '../../Map/siteMarker.png';
import './FolderInstructionsModal.css';

// const buttonIcon = type => {
//   let icon;
//   if (type === 'Create') {
//     icon = addFolderIcon;
//   } else if (type === 'Delete') {
//     icon = deleteFolderIcon;
//   } else if (type === 'Rename') {
//     icon = renameFolderIcon;
//   }
//   return svgInline(icon);
// };

// const createButton = button => (
//   <ViewerSecondaryColorUserStyle domStyle="backgroundColor">
//     <span className="button">
//       {buttonIcon(button)}
//       {button}
//     </span>
//   </ViewerSecondaryColorUserStyle>
// );

function FolderInstructionsModal({
  onModalClick,
}) {
  return (
    <div className="modal-wrapper folder-instructions-modal">
      <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
        <div className="modal-header">
          <h2 className="modal-title">My Folders Guide</h2>
          <a tabIndex="0" onClick={onModalClick}>
            <div className="modal-close">
              {svgInline(closeIcon)}
            </div>
          </a>
        </div>
      </ViewerPrimaryColorUserStyle>
      <div className="modal-body">
        <p>NOTE: The colors displayed in the guide may or may not be reflected on your site since
        LOIS allows custom color configuration.</p><br />
        <section>
          <h3>Manage Your Folders</h3>
          <ul>
            <li>The <strong>Folder Manager</strong> allows you to manage all your folders
              <img className="folder-manager" src={folderManager} alt="Folder Manager" />
            </li>
            <li>
              The <strong>My Folders List</strong> dropdown contains a list of folders that have
               been created.
            </li>
            <li>
              If you have no folders created the default <strong>Untitled Folder</strong> will
               be the only one in the list.</li>
            <li>Change the active folder by choosing a different folder in the dropdown.</li>
            <li>
              Use the <img className="folder-btn" src={addFolderImg} alt="Folder Create" />
              button to create a new folder.</li>
            <li>
              Use the <img className="folder-btn" src={renameFolderImg} alt="Folder Rename" />
               button to rename the currently selected folder (tip: you can rename the
               default Untitled Folder to make it more user friendly).</li>
            <li>
              Use the <img className="folder-btn" src={deleteFolderImg} alt="Folder Delete" />
               button to delete the currently selected folder (tip: if you had items saved
               to this folder they will no longer be saved after folder is deleted).</li>
          </ul>
        </section>
        <section>
          <h3>Adding/Removing Individual Items To Folders</h3>
          <ul>
            <li>Look for the folder icon <span className="folder-icon">{svgInline(folderIcon)}</span>
              on the item in the Building, Sites and Areas pages. Items already saved to
              folder(s) will be highlighted <span className="folder-icon">{svgInline(folderIconActive)}</span>
            </li>
            <li>Clicking on the folder icon will add or remove the item from the default folder:
              &nbsp;<strong>Untitled Folder</strong>
            </li>
            <li>If you have already created folders, clicking on the folder icon opens the
              &nbsp;<strong>Folder Manager</strong> modal
              &nbsp;<img className="folder-manager-multiselect" src={foldersModalMultiselectImg} alt="Folder Manager Modal" />
            </li>
            <li>A list of existing folders will be displayed. If the checkbox beside the folder
              is checked, the item is already saved to the folder. Toggle the checkbox on/off
              for each folder you want to save the item to.
            </li>
            <li>You can also create a new folder from within the modal by clicking on the
              &nbsp;<strong>Create</strong> button. Enter a new folder name and Save. The new
              folder will be displayed in the list where you can select it.
            </li>
          </ul>
        </section>
        <section>
          <h3>Adding/Removing In Bulk</h3>
          <ul>
            <li>Multiple Buildings and Sites can be added to a folder at once. At the top of
               the property list, click on the <strong>Add All To Favorites</strong> or
               &nbsp;<strong>Remove All From Favorites</strong> to remove properties.
              <img className="folder-manager-bulk" src={folderBulkActionImg} alt="Folder Manager Bulk Actions" />
            </li>
            <li>You can only choose 1 folder at a time to add/remove items for bulk actions.
              <div className="folder-manager-bulk-action">
                <img src={folderBulkAddImg} alt="Folder Manager Bulk Add" />
                <img src={folderBulkRemoveImg} alt="Folder Manager Bulk Remove" />
              </div>
            </li>
            <li>The items that will be added or removed applies to the current property list.
               Use the main <strong>Search</strong> to filter the property list if you want to
               narrow your results for bulk adding.
            </li>
            <li>Removing items in bulk may not necessarily remove all items from a specified folder
               as the remove only occurs on items in the current property list. For example, search
               filter is applied that reduces the property list to 10 properties, all 10 are
               saved to a folder, search filter is removed and full property list is displayed. The
               current property list only displays the first 100 results and only 3 of the 10 that
               were saved are in this list. The remove bulk action would only remove those 3
               properties. See the next section for instructions on removing all items from folders.
            </li>
          </ul>
        </section>
        <section>
          <h3>Remove All Items From Folder</h3>
          <ul>
            <li>All items can be removed from a folder using the <strong>Remove All</strong>&nbsp;
             button on the <strong>My Folders</strong> page. Look for this button at the
             top of of each saved list (Buildings or Sites). If your site has Areas enabled,
             each area type (State, Region, County, Communities) will have its own button.
             This action would remove all of a specific item type from the active folder.
            </li>
            <li>Alternatively the folder could be deleted entirely which would remove all
              items from all item types at the same time.
            </li>
          </ul>
        </section>
        <section>
          <h3>View Your Saved Items</h3>
          <ul>
            <li>Once there are saved Building, Site or Area items, they will display on the
              respective sections on the <strong>My Folders</strong> page. A map will display
              below the saved list(s) with map markers for Buildings and Sites.
            </li>
            <li>Only the items saved to the current active folder will be displayed. To see
              items in a different folder, change the active folder by selecting a new folder
              in the <strong>My Folders List</strong> dropdown.
            </li>
            <li>For Buildings and Sites, click on the map marker icon&nbsp;
              <img className="folders-mapmarker" src={siteMarker} alt="Map Marker" /> to
               scroll to the property on the map</li>
            <li>Use the drag handle&nbsp;
              <span className="drag-handle">{'\u2630'}</span> to click and drag an item
               to re-order the saved list.</li>
            <li>Click on the saved item to route to the detail page for that item.</li>
          </ul>
          <img className="folders-full" src={foldersFullImg} alt="My Folders" />
        </section>
        <ViewerPrimaryColorUserStyle domStyle="backgroundColor">
          <button
            type="button"
            onClick={() => { onModalClick(); }}
            className="btn"
          >
            CLOSE
          </button>
        </ViewerPrimaryColorUserStyle>
      </div>
    </div>
  );
}

FolderInstructionsModal.propTypes = {
  onModalClick: PropTypes.func,
};

export default withModal(FolderInstructionsModal, 'folder-instructions-modal');



// WEBPACK FOOTER //
// ./src/components/Favorites/FolderInstructionsModal/FolderInstructionsModal.js